module.exports = __webpack_public_path__ + "static/media/startstop2.f59259f2.wav";